var map = {
	"./footer.de-CH.json": 1099,
	"./footer.de-DE.json": 1100,
	"./footer.en-CA.json": 1101,
	"./footer.en-GB.json": 1102,
	"./footer.en-IN.json": 1103,
	"./footer.en-ME.json": 1104,
	"./footer.en-US.json": 1105,
	"./footer.es-EM.json": 1106,
	"./footer.es-ES.json": 1107,
	"./footer.fr-BE.json": 1108,
	"./footer.fr-CA.json": 1109,
	"./footer.fr-CH.json": 1110,
	"./footer.nl-BE.json": 1111,
	"./footer.nl-NL.json": 1112,
	"./footer.pl-PL.json": 1113,
	"./footer.pt-BR.json": 1114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1098;